var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGradeB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12C0.5 5.64873 5.64873 0.5 12 0.5H28H44C50.3513 0.5 55.5 5.64873 55.5 12V44C55.5 50.3513 50.3513 55.5 44 55.5H12C5.64873 55.5 0.5 50.3513 0.5 44V12Z",
    fill: "url(#paint0_linear_3315_18408)",
    stroke: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5139 38.5001V18.1365H28.6673C30.1654 18.1365 31.415 18.3585 32.4159 18.8027C33.4169 19.2468 34.1692 19.8633 34.673 20.6521C35.1768 21.4343 35.4287 22.3358 35.4287 23.3566C35.4287 24.1521 35.2696 24.8514 34.9514 25.4547C34.6332 26.0512 34.1957 26.5418 33.6389 26.9262C33.0887 27.3041 32.459 27.5726 31.7497 27.7316V27.9305C32.5253 27.9637 33.2511 28.1824 33.9273 28.5868C34.61 28.9911 35.1635 29.5579 35.5878 30.287C36.012 31.0096 36.2241 31.8713 36.2241 32.8723C36.2241 33.9528 35.9557 34.9173 35.4187 35.7657C34.8884 36.6076 34.1029 37.2738 33.0622 37.7643C32.0215 38.2549 30.7388 38.5001 29.2142 38.5001H20.5139ZM24.8193 34.9802H28.3293C29.5291 34.9802 30.4041 34.7515 30.9543 34.2941C31.5044 33.8301 31.7795 33.2137 31.7795 32.4447C31.7795 31.8813 31.6437 31.3841 31.3719 30.9532C31.1001 30.5224 30.7123 30.1843 30.2085 29.939C29.7114 29.6938 29.1181 29.5711 28.4287 29.5711H24.8193V34.9802ZM24.8193 26.6578H28.0111C28.601 26.6578 29.1247 26.555 29.5821 26.3495C30.0461 26.1374 30.4107 25.8391 30.6758 25.4547C30.9476 25.0702 31.0835 24.6095 31.0835 24.0726C31.0835 23.3368 30.8217 22.7435 30.298 22.2927C29.781 21.842 29.0452 21.6166 28.0906 21.6166H24.8193V26.6578Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3315_18408",
    x1: 0,
    y1: 0,
    x2: 56,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175644,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342321,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGradeB);
export default __webpack_public_path__ + "static/media/icon-grade-B.d361ae5ae9e68fb5d699eb04fcf6b4d0.svg";
export { ForwardRef as ReactComponent };